import { Card, CardContent, Grid } from "@mui/material";
import React, { useEffect, useState } from "react";
import {
  GRN_ORDER_COLUMN,
  QC_DETAILS,
  QC_REJECTED_COLUMNS,
} from "../../columns/columns";
import CounterCard from "../../components/CounterCard";
import {
  getQClineItemsByReceiptId,
  getWareHouseReciptDetails,
  requestQcRejectHistory,
} from "../../services/dataService";
import GRNTable from "../../components/table/GRNTable";
import { dateBeforeMonths, today } from "../../manager/dateManager";
import { createQCCard, getQCCardCount } from "../../manager/cardManager";
import {
  dispatcher,
  requestGRNFromStore,
  requestRejectedQCHistoryFromStore,
} from "../../store/helper";
import {
  GOOD_RECEIVE_NOTE_LOADED,
  REJECTED_QC_HISTORY,
} from "../../store/ActionType";
import store from "../../store/Store";
import { getUser } from "../../services/authService";
import { SUPPLIER_GRN_ORDER_COLUMN } from "../../columns/supplier-columns";

function QualityCheck() {
  const user = getUser();
  const [tableData, setTableData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [PONumber, setPONumber] = useState("");
  const [RCPTNumber, setRCPTNumber] = useState("");
  const [fromDate, setFromDate] = useState(dateBeforeMonths(4));
  const [toDate, setToDate] = useState(today());
  const [overviewItems, setOverviewItems] = useState(createQCCard("loading"));
  const [activeCard, setActiveCard] = useState(
    localStorage.getItem("qualityCheck") || "QC Approved"
  );

  const getGRN = async () => {
    var grnList = [];
    var qcRejectHistory = [];
    setLoading(true);
    try {
      const response = await getWareHouseReciptDetails({
        FromDate: fromDate,
        ToDate: toDate,
        PONumber: PONumber,
        RCPTNO: RCPTNumber,
      });
      grnList = response.data;
      dispatcher(GOOD_RECEIVE_NOTE_LOADED, response.data);
    } catch (error) {
      setTableData([]);
    }
    try {
      const qcRejectHistoryresponse = await requestQcRejectHistory({
        FromDate: fromDate,
        Todate: toDate,
      });
      qcRejectHistory = qcRejectHistoryresponse.data;
      dispatcher(REJECTED_QC_HISTORY, qcRejectHistoryresponse.data);
    } catch (error) {}
    setOverviewItems(createQCCard(getQCCardCount(grnList, qcRejectHistory)));
    setLoading(false);
  };

  const sortingHandler = async (status) => {
    localStorage.setItem("qualityCheck", status);
    setActiveCard(status);
    const qcStoreData = requestGRNFromStore();
    const qcRejectHistory = requestRejectedQCHistoryFromStore();
    if (status === "QC Pending") {
      var pendingQC = [];
      for (const qc of qcStoreData) {
        if (qc && (!qc.QCRemarks || qc.QCRemarks === "Qc Pending")) {
          pendingQC.push(qc);
        }
      }
      setTableData(pendingQC);
    } else if (status === "QC Approved") {
      var doneQC = [];
      for (const qc of qcStoreData) {
        if (qc && qc.QCRemarks === "Qc Done") {
          doneQC.push(qc);
        }
      }
      setTableData(doneQC);
    } else if (status === "Overall QC Rejected") {
      setTableData(qcRejectHistory);
    }
    setOverviewItems(
      createQCCard(getQCCardCount(qcStoreData, qcRejectHistory))
    );
  };

  useEffect(() => {
    getGRN();
    const unsubscribe = store.subscribe(() => {
      sortingHandler(activeCard);
    });
    return () => {
      unsubscribe();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getColumns = (status) => {
    if (status === "Overall QC Rejected") {
      return QC_REJECTED_COLUMNS;
    } else {
      if (
        user?.globalID ||
        user?.isSupplierOperation ||
        user?.isSupplierFinance
      ) {
        return SUPPLIER_GRN_ORDER_COLUMN;
      } else {
        return GRN_ORDER_COLUMN;
      }
    }
  };

  return (
    <>
      <Grid container spacing={2} marginTop={0}>
        <Grid container spacing={2}>
          {overviewItems.map((item, index) => (
            <Grid key={index} item xs={12} sm={6} md={6} lg={3}>
              <CounterCard
                description={item.name}
                title={item.value}
                icon={item.icon}
                color={item.dark}
                bgColor={item.light}
                onClickHandler={() => {
                  sortingHandler(item.name);
                }}
                isActive={activeCard === item.name}
              />
            </Grid>
          ))}
          <Grid item xs={12} md={12}>
            <Card>
              <CardContent>
                <GRNTable
                  data={tableData}
                  columns={getColumns(activeCard)}
                  fromDate={fromDate}
                  toDate={toDate}
                  handleFromDate={(e) => setFromDate(e.target.value)}
                  handleToDate={(e) => setToDate(e.target.value)}
                  callAPI={getGRN}
                  PONumber={PONumber}
                  setPONumber={(e) => setPONumber(e.target.value)}
                  RCPTNumber={RCPTNumber}
                  setRCPTNumber={(e) => setRCPTNumber(e.target.value)}
                  loading={loading}
                  detailsAPI={getQClineItemsByReceiptId}
                  detailsColumn={QC_DETAILS}
                  moduleName="QC"
                />
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      </Grid>
    </>
  );
}

export default QualityCheck;
